
<nav-bar></nav-bar>
<div class="page-reports scroller column">
  <w-validation-panel *ngIf="searchError" type="error" [details]="searchError.message"></w-validation-panel>
  <div class="deletedReports">
    <ul>
      <li class="textBlock" *ngFor="let deletedReport of rs.deletedReports.st13 | keyvalue"><span>Report&nbsp;</span><b>{{deletedReport.key}}&nbsp;</b><span>deleted.&nbsp;</span><a (click)="rs.undeleteReport(deletedReport.key)">Undo</a><span>&nbsp;({{ rs.deletedReportsCountdowns[deletedReport.key] | async }})</span></li>
    </ul>
  </div>
  <div class="textBlock noReports" *ngIf="!rs.reportsNames.length; else yesReports" innerHTML="{{ 'page_reports.no_reports' | translate }}"></div>
  <ng-template #yesReports>
    <w-page-section *ngFor="let report of rs.reports.st13 | keyvalue; let i = index" title="{{ report.key + ' (' + report.value.st13s.length + ')' }}" [collapsed]="report.value.collapsed" (wChange)="toggleReport($event, report.key)">
      <f-facet *ngIf="!ms.isLoading" name="header-actions">
        <button w-button size="small" [label]="ms.translate('buttons.export_to_pdf' )" *ngIf="rs.reports.st13[report.key].st13s.length" (click)="doExport(report.key, 'pdf')"></button>
        <button w-button size="small" [label]="ms.translate('buttons.export_to_xls' )" *ngIf="rs.reports.st13[report.key].st13s.length" (click)="doExport(report.key, 'xlsx')"></button>
        <button w-button size="small" [label]="ms.translate('buttons.export_to_docx' )" *ngIf="rs.reports.st13[report.key].st13s.length" (click)="doExport(report.key, 'docx')"></button>
        <button w-button size="small" [label]="ms.translate('buttons.delete' )" (click)="rs.deleteReport(report.key)"></button>
      </f-facet>
      <f-facet *ngIf="isExporting || !ms.isLoading" name="content">
        <div *ngIf="!rs.reports.st13[report.key].st13s.length">{{ 'page_reports.report_empty' | translate }}.</div>
        <w-action-bar *ngIf="isSomeResultSelected(report.key)">
          <button w-button facet-buttons size="small" label="{{ 'page_reports.remove_from_report' | translate }}" (click)="removeFromReport(report.key)"></button>
        </w-action-bar>
        <results-list-gbd *ngIf="ms.instanceType=='gbd'" [docs]="reports[report.key]?.response.docs"></results-list-gbd>
        <results-list-gdd *ngIf="ms.instanceType=='gdd'" [docs]="reports[report.key]?.response.docs"></results-list-gdd>
      </f-facet>
    </w-page-section>
  </ng-template>
</div>
